import axios from 'axios'

const TATTLEBOOTSTRAP = 'https://api.dev.tattleapp.io/surveys/api/customer-survey/widget/bootstrap'
const TATTLEQUESTIONNAIRE = 'https://api.dev.tattleapp.io/surveys/api/customer-survey/widget/questionnaires'
const TATTLESNAPSHOTS = 'https://api.dev.tattleapp.io/surveys/api/customer-survey/widget/questionnaire-questions'

export async function fetchBoostrapData(slug: string) {
  try {
    const response = await axios.post(TATTLEBOOTSTRAP, { slug })
    return response.data
  } catch (error) {
    console.error('Error posting locations:', error)
  }
}

export async function fetchQuestionnaireData(merchantId: number, locationId: number) {
  try {
    const response = await axios.post(TATTLEQUESTIONNAIRE, { merchantId, locationId })
    return response.data
  } catch (error) {
    console.error('Error posting questionnaires:', error)
  }
}

export async function fetchSnapshotData(merchantId: number, locationId: number, questionnaireId: number) {
  try {
    const response = await axios.post(TATTLESNAPSHOTS, { merchantId, locationId, questionnaireId })
    return response.data
  } catch (error) {
    console.error('Error posting snapshots:', error)
  }
}
